import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Home from "@/pages/Home";
import Catalog from "@/pages/Catalog";
import Scan from "@/pages/Scan";
import ArtifactDetail from "@/pages/ArtifactDetail";
import Stats from "@/pages/Stats";
import PublicShare from "@/pages/PublicShare";
import PublicCatalog from "@/pages/PublicCatalog";
import Settings from "@/pages/Settings";
import MapPage from "@/pages/MapPage";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ChangePassword from "@/pages/ChangePassword";
import ProtectedRoute from "@/components/ProtectedRoute";
import { ThemeProvider } from "@/lib/theme";
import { AuthProvider, useAuth } from "@/lib/auth";
import { Camera } from "@phosphor-icons/react";

function ScanFAB() {
  const { user } = useAuth();
  if (!user) return null;
  return (
    <Link
      to="/scan"
      className="md:hidden fixed bottom-6 right-6 z-40 bg-[#1E2520] text-white rounded-full p-4 shadow-xl flex items-center gap-2 hover:bg-[#2C352F] transition-all"
      data-testid="scan-fab"
      aria-label="Identifica reperto"
    >
      <Camera weight="duotone" size={22} />
    </Link>
  );
}

function AuthAwareLayout({ children }) {
  const { user } = useAuth();
  return (
    <>
      {user && <Navbar />}
      <main>{children}</main>
      <ScanFAB />
      {user && (
        <footer className="mt-16 py-10 border-t border-black/5 text-center text-xs text-[#5C635A]">
          Reperti · Catalogo personale alimentato dall'AI
        </footer>
      )}
    </>
  );
}

export default function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <div className="App">
          <BrowserRouter>
            <Routes>
              {/* Public routes */}
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/share/:token" element={<PublicShare />} />
              <Route path="/share/catalog/:token" element={<PublicCatalog />} />

              {/* Protected routes */}
              <Route path="/*" element={
                <AuthAwareLayout>
                  <Routes>
                    <Route path="/" element={<ProtectedRoute><Home /></ProtectedRoute>} />
                    <Route path="/catalog" element={<ProtectedRoute><Catalog /></ProtectedRoute>} />
                    <Route path="/catalog/:category" element={<ProtectedRoute><Catalog /></ProtectedRoute>} />
                    <Route path="/scan" element={<ProtectedRoute><Scan /></ProtectedRoute>} />
                    <Route path="/artifact/:id" element={<ProtectedRoute><ArtifactDetail /></ProtectedRoute>} />
                    <Route path="/stats" element={<ProtectedRoute><Stats /></ProtectedRoute>} />
                    <Route path="/map" element={<ProtectedRoute><MapPage /></ProtectedRoute>} />
                    <Route path="/map/:country" element={<ProtectedRoute><MapPage /></ProtectedRoute>} />
                    <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
                    <Route path="/change-password" element={<ProtectedRoute allowForcedChange><ChangePassword /></ProtectedRoute>} />
                    <Route path="*" element={<ProtectedRoute><Home /></ProtectedRoute>} />
                  </Routes>
                </AuthAwareLayout>
              } />
            </Routes>
          </BrowserRouter>
        </div>
      </AuthProvider>
    </ThemeProvider>
  );
}
